import { createContext } from 'react';
import {
  tDriveFilesActionContext,
  tStringMap,
} from './DriveFilesAction.types.ts';

export const initialState: tDriveFilesActionContext = {
  isDropdownOpen: false,
  setIsDropdownOpen: () => {},
  dropdownRef: null,
  setSelectedFiles: () => {},
  selectedFiles: [],
  fileRef: null,
  setShowUploadFile: () => {},
  showUploadFile: false,
  saveOnDrive: false,
  setSaveOnDrive: () => {},
  isLastPage: false,
  setIsLastPage: () => {},
  cursor: '',
  setCursor: () => {},
  getMoreLeads: async () => null,
};

export const DriveFilesActionContext =
  createContext<tDriveFilesActionContext>(initialState);

export const fileIconMap: tStringMap = {
  pdf: '/images/storage/pdfIcon.png',
  doc: '/images/storage/docIcon.png',
  docx: '/images/storage/docIcon.png',
  xls: '/images/storage/xlsIcon.png',
  xlsx: '/images/storage/xlsIcon.png',
  ppt: '/images/storage/pptIcon.png',
  pptx: '/images/storage/pptIcon.png',
  jpeg: '/images/storage/imagesIcon.png',
  jpg: '/images/storage/imagesIcon.png',
  png: '/images/storage/imagesIcon.png',
};

export const AcceptFilesInstagram = 'image/*,video/*,audio/*';
export const AcceptFilesAll =
  '.xlsx,.xls,.csv,image/*,video/*,audio/*,.doc, .docx,.ppt, .pptx,.txt,.pdf';
